import {
  IsUUID,
  IsEmail,
  IsString,
  IsEnum,
  IsOptional,
  IsDateString,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  UsersResponseInterface,
  MiniUsersResponseInterface,
  UserStatus,
  UserRole,
  UserPosition,
} from '../../interface/users/users-response.interface';

import { AttachmentsDto } from '../attachments/attachments.dto';

export class MiniUsersDto implements MiniUsersResponseInterface {

  @IsUUID()
  id!: string;

  @IsEmail()
  email!: string;

  @IsEnum(UserRole)
  role!: UserRole;

  @IsOptional()
  @IsString()
  first_name!: string | null;

  @IsOptional()
  @IsString()
  last_name!: string | null;

  @IsOptional()
  @IsString()
  phone_number!: string | null;

  @IsEnum(UserPosition)
  position!: UserPosition;
}

export class UsersDto implements UsersResponseInterface {

  @IsUUID()
  id!: string;

  @IsEmail()
  email!: string;

  @IsEnum(UserRole)
  role!: UserRole;

  @IsOptional()
  @IsString()
  first_name!: string | null;

  @IsOptional()
  @IsString()
  last_name!: string | null;

  @IsOptional()
  @IsString()
  phone_number!: string | null;

  @IsEnum(UserStatus)
  status!: UserStatus;

  @IsEnum(UserPosition)
  position!: UserPosition;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => AttachmentsDto)
  attachment_signature!: AttachmentsDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => AttachmentsDto)
  attachment_avatar!: AttachmentsDto | null;
}